var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V4C12.75 4.41421 12.4142 4.75 12 4.75C11.5858 4.75 11.25 4.41421 11.25 4V2C11.25 1.58579 11.5858 1.25 12 1.25ZM1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H4C4.41421 11.25 4.75 11.5858 4.75 12C4.75 12.4142 4.41421 12.75 4 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12ZM19.25 12C19.25 11.5858 19.5858 11.25 20 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H20C19.5858 12.75 19.25 12.4142 19.25 12ZM12 19.25C12.4142 19.25 12.75 19.5858 12.75 20V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20C11.25 19.5858 11.5858 19.25 12 19.25Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6687 3.7156C3.9482 3.4099 4.4226 3.38867 4.7283 3.66817L6.95032 5.69975C7.25602 5.97925 7.27726 6.45365 6.99776 6.75935C6.71826 7.06505 6.24386 7.08629 5.93816 6.80679L3.71614 4.7752C3.41044 4.4957 3.3892 4.0213 3.6687 3.7156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3314 3.7156C20.6109 4.0213 20.5897 4.4957 20.284 4.7752L18.062 6.80679C17.7563 7.08629 17.2819 7.06505 17.0024 6.75935C16.7229 6.45365 16.7441 5.97925 17.0498 5.69975L19.2718 3.66817C19.5775 3.38867 20.0519 3.4099 20.3314 3.7156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0256 17.0247C17.3185 16.7318 17.7934 16.7319 18.0862 17.0248L20.3082 19.2471C20.6011 19.54 20.6011 20.0148 20.3082 20.3077C20.0153 20.6006 19.5404 20.6006 19.2475 20.3076L17.0255 18.0854C16.7326 17.7924 16.7327 17.3176 17.0256 17.0247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97472 17.0249C7.26761 17.3177 7.26761 17.7926 6.97472 18.0855L4.7525 20.3077C4.4596 20.6006 3.98473 20.6006 3.69184 20.3077C3.39894 20.0148 3.39894 19.54 3.69184 19.2471L5.91406 17.0248C6.20695 16.732 6.68183 16.732 6.97472 17.0249Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.94cf1da58d28c58868c779c5e2193c12.svg";
export { ForwardRef as ReactComponent };